// Phase 23 / Plan 23-04 — MolliePaymentSection re-export.
// Innenleben implementiert in Plan 23-05.
export {MolliePaymentSection, default} from "./MolliePaymentSection";
export type {MolliePaymentSectionProps} from "./MolliePaymentSection";
